<ta-flexbox justifyContent="center">
  <div class="auth-page-hero">
    <ta-flexbox class="auth-page-hero-text" justifyContent="center" alignItems="center">
      <img id="tapad-logo" src="/local/assets/images/TTG_Lockup.png" alt="Tapad Logo"/>
    </ta-flexbox>
  </div>
  <ta-flexbox class="auth-page-container" flexDirection="column" justifyContent="center" alignItems="center">
    <img id="tapad-logo-mobile" src="/local/assets/images/TTG_Lockup_mobile.png" alt="Tapad Logo" />
    <div class="auth-form-container">
      <div class="auth-form-content">
        <ng-content></ng-content>
      </div>
      <!--AUTH FOOTER-->
      <ta-flexbox class="auth-footer" justifyContent="center">
        <ta-link
          href="https://www.tapad.com/about"
          target="_blank"
        >
          NEW TO TAPAD
        </ta-link>
        &nbsp;&nbsp;&nbsp;
        <ta-link
          href="https://www.tapad.com/privacy-policy/"
          target="_blank"
        >
          PRIVACY POLICY
        </ta-link>
      </ta-flexbox>
    </div>
  </ta-flexbox>
</ta-flexbox>
